import { getJsonList, setJsonList } from "lib/storage/local-storage";

import type { UpdateQuoteInput } from "./get-quotes";

const QUOTES_KEY = "fb-reader-quotes";

type LocalQuote = UpdateQuoteInput & {
  artId: number;
};

export function getLocalQuotes(artId: number): LocalQuote[] {
  const all = getJsonList<LocalQuote>(QUOTES_KEY);
  return all.filter(q => q.artId === artId);
}

export function addLocalQuote(quote: UpdateQuoteInput, artId: number): void {
  const all = getJsonList<LocalQuote>(QUOTES_KEY);
  const filtered = all.filter(q => q.id !== quote.id);
  filtered.push({ ...quote, artId });
  setJsonList(QUOTES_KEY, filtered);
}

export function updateLocalQuote(
  quoteId: string,
  updates: Partial<UpdateQuoteInput>
): void {
  const all = getJsonList<LocalQuote>(QUOTES_KEY);
  const updated = all.map(q => (q.id === quoteId ? { ...q, ...updates } : q));
  setJsonList(QUOTES_KEY, updated);
}

export function deleteLocalQuote(quoteId: string): void {
  const all = getJsonList<LocalQuote>(QUOTES_KEY);
  const filtered = all.filter(q => q.id !== quoteId);
  setJsonList(QUOTES_KEY, filtered);
}
